import { Component, Inject, OnInit } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { ObservableRequestService } from 'app/services/observable-request.service';
import { FinanceService } from 'app/finance/finance.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { BankStatementPreviewComponent } from 'app/entities/transaction-monitoring/bank-statement-preview/bank-statement-preview.component';

export interface DuplicateTxRow {
  transaction: any;
  transactionId?: string;
  existingTransaction?: {
    transactionId?: string;
    date?: string;
    amount?: string;
    description?: string;
    counterparty?: string;
    bankStatementId?: number;
  };
}

export interface DuplicatesInvestigationDialogData {
  bankStatement: any; // BankStatementBatchItem
  duplicateCount: number;
  total: number;
  duplicates: DuplicateTxRow[];
}

@Component({
  selector: 'app-duplicates-investigation-dialog',
  templateUrl: './duplicates-investigation-dialog.component.html',
  styleUrls: ['./duplicates-investigation-dialog.component.css']
})
export class DuplicatesInvestigationDialogComponent implements OnInit {
  otherStatements: Map<number, any> = new Map(); // id -> details from /bank-statement/{id}
  loadingOtherStatements = false;

  constructor(
    public dialogRef: MdDialogRef<DuplicatesInvestigationDialogComponent>,
    @Inject(MD_DIALOG_DATA) public data: DuplicatesInvestigationDialogData,
    private requestService: ObservableRequestService,
    private financeService: FinanceService,
    private snackBarService: SnackBarService,
    private dialog: MdDialog
  ) {}

  ngOnInit() {
    this.loadOtherStatementDetails();
  }

  close() {
    this.dialogRef.close();
  }

  getOtherStatementLabel(id: number | null | undefined): string {
    if (!id) {
      return '-';
    }
    const details = this.otherStatements.get(id);
    if (details && (details.originalName || details.uniqueNameId)) {
      return details.originalName || details.uniqueNameId;
    }
    return String(id);
  }

  previewStatementById(bankStatementId: number) {
    if (!bankStatementId) {
      return;
    }
    const config = new MdDialogConfig();
    config.width = '80%';
    config.height = '80%';
    config.data = { bankStatementId };
    this.dialog.open(BankStatementPreviewComponent, config);
  }

  previewCurrent() {
    const id = this.data && this.data.bankStatement ? this.data.bankStatement.id : null;
    if (id) {
      this.previewStatementById(id);
    }
  }

  deleteStatement(bankStatementId: number) {
    if (!bankStatementId) {
      return;
    }
    if (!confirm('Are you sure you want to delete this bank statement?')) {
      return;
    }
    this.financeService.deleteBankStatement(String(bankStatementId)).subscribe(
      () => {
        this.snackBarService.showSimpleMsj('Bank statement deleted successfully.');
        this.dialogRef.close({ refresh: true });
      },
      (error: any) => {
        this.snackBarService.showSimpleMsj('Cannot delete bank statement: ' + (error.message || 'Unknown error'));
      }
    );
  }

  private loadOtherStatementDetails() {
    const duplicates = (this.data && this.data.duplicates) ? this.data.duplicates : [];
    const ids = new Set<number>();
    duplicates.forEach(d => {
      const otherId = d && d.existingTransaction ? d.existingTransaction.bankStatementId : null;
      if (otherId) {
        ids.add(otherId);
      }
    });
    const idList = Array.from(ids);
    if (idList.length === 0) {
      return;
    }
    this.loadingOtherStatements = true;
    let remaining = idList.length;

    idList.forEach(id => {
      this.requestService.getRequest(`/bank-statement/${id}`).subscribe(
        (res: any) => {
          // Backend returns a JSON string sometimes; ObservableRequestService typically parses JSON already.
          this.otherStatements.set(id, res);
          remaining--;
          if (remaining === 0) {
            this.loadingOtherStatements = false;
          }
        },
        () => {
          remaining--;
          if (remaining === 0) {
            this.loadingOtherStatements = false;
          }
        }
      );
    });
  }

  formatTxField(tx: any, field: string): string {
    if (!tx) return '-';
    const v = tx[field];
    if (v === null || v === undefined || v === '') return '-';
    return String(v);
  }
}




// WEBPACK FOOTER //
// ./src/app/finance/bank-statements-batch/duplicates-investigation-dialog/duplicates-investigation-dialog.component.ts